export function squareBracketsToDots(queryParams: string) {
  return queryParams.replaceAll('[', '.').replaceAll(']', '')
}
